import type { Maybe } from '@adornis/base/utilTypes.js';

/**
 * Enum for the state of a work tracking activity.
 */
export enum WorkTrackingTaetigkeitenState {
  OPEN = 'Offen',
  QUESTION = 'Klärung',
  FINISHED = 'Geklärt',
}

export function combinedTrackingTaetigkeitenState(values: Maybe<WorkTrackingTaetigkeitenState>[]) {
  if (values.some(v => v === WorkTrackingTaetigkeitenState.QUESTION)) {
    return WorkTrackingTaetigkeitenState.QUESTION;
  }
  if (values.some(v => v === WorkTrackingTaetigkeitenState.OPEN || !v)) {
    return WorkTrackingTaetigkeitenState.OPEN;
  }
  return WorkTrackingTaetigkeitenState.FINISHED;
}
